export const NOTIFICATION_POSITIONS = {
  TOP_RIGHT: "top-right",
  TOP_LEFT: "top-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_LEFT: "bottom-left",
  TOP_CENTER: "top-center",
  BOTTOM_CENTER: "bottom-center",
};

export const NOTIFICATION_DURATIONS = {
  SHORT: 3000,
  MEDIUM: 5000,
  LONG: 10000,
};

export const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};

export const MODAL_TYPES = {
  PRIVACY_POLICY: "privacy-policy",
  TERMS_OF_SERVICE: "terms-of-service",
  COOKIE_POLICY: "cookie-policy",
  LEGAL_NOTICE: "legal-notice",
  CONTACT_US: "contact-us",
  ABOUT_US: "about-us",
  HELP: "help",
  FEEDBACK: "feedback",
  SUPPORT: "support",
  ASSIGN_ROLE: "assign-role",
  ASSIGN_USERS_TO_GROUP: "assign-users-to-group",
  ASSIGN_SCENARIOS_TO_GROUP: "assign-scenarios-to-group",
  DELETE_GROUP: "delete-group",
  DELETE_GROUP_USER: "delete-group-user",
  DELETE_GROUP_SCENARIO: "delete-group-scenario",
  DELETE_LTI_PLATFORM: "delete-lti-platform",
  DELETE_LTI_CONFIG: "delete-lti-config",
  DELETE_USER_GROUP: "delete-user-group",
  DELETE_CONVERSATION: "delete-conversation",
  CHANGE_GROUP_CLIENT: "change-group-client",
  CHANGE_USER_CLIENT: "change-user-client",
  DELETE_CLIENT_SCENARIO: "delete-client-scenario",
  DELETE_CLIENT_GROUP: "delete-client-group",
  DELETE_USER: "delete-user",
  DELETE_CLIENT: "delete-client",
  DELETE_ROLE: "delete-role",
  DELETE_FILE_MAP: "delete-file-map",
  DELETE_ACTOR: "delete-actor",
  CONFIRM: "confirm",
};
